export default (err, name) => {
  let snackbar = {};
  snackbar.color = "error";
  if (err.graphQLErrors && err.graphQLErrors.length > 0) {
    snackbar.text = err.graphQLErrors
      ? err.graphQLErrors.reduce((acc, curr) => {
          return `${acc}\n${
            curr.data.message ? curr.data.message : curr.message
          }`;
        }, "")
      : `Failed to load the ${name}. Please try again later.`;
  } else {
    snackbar.text = `Network Error: Failed to load the ${name}. Please try again later.`;
  }
  snackbar.show = true;

  return snackbar;
};
